module.exports = __webpack_public_path__ + "static/media/fmpLogo.431b3c85.png";